var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10563",
    "data-name": "Group 10563",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3058",
    "data-name": "Rectangle 3058",
    width: 22,
    height: 22,
    fill: "#2e728c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10562",
    "data-name": "Group 10562",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28904",
    "data-name": "Path 28904",
    d: "M18.115,12.479a6.281,6.281,0,0,1-.859-.31A5.642,5.642,0,0,0,19.25,7.6a4.181,4.181,0,0,0-4.193-4.159A4.126,4.126,0,0,0,11,0,4.19,4.19,0,0,0,6.943,3.438,4.168,4.168,0,0,0,2.75,7.529a6.043,6.043,0,0,0,1.995,4.607l-.036.034a7.607,7.607,0,0,1-.823.31C2.44,12.958,0,13.784,0,16.6v1.854a.689.689,0,0,0,.688.688h2.13a5.736,5.736,0,0,0-.068.792v1.375A.69.69,0,0,0,3.438,22H18.563a.69.69,0,0,0,.688-.687V19.938a5.736,5.736,0,0,0-.068-.792h2.13A.689.689,0,0,0,22,18.458V16.6c0-2.82-2.44-3.646-3.885-4.125M17.875,7.6c0,1.719-.893,3.575-2.406,3.987a8.287,8.287,0,0,0,.344-2.3,4.708,4.708,0,0,0-2.268-4.057,3.184,3.184,0,0,1,1.477-.412A2.809,2.809,0,0,1,17.875,7.6M7.563,9.281a3.438,3.438,0,0,1,6.875,0c0,2.544-1.719,5.156-3.437,5.156S7.563,11.825,7.563,9.281M11,1.375a2.758,2.758,0,0,1,2.682,2.268,5.036,5.036,0,0,0-1.617.93A5.542,5.542,0,0,0,11,4.435a3.6,3.6,0,0,0-1.065.138,3.979,3.979,0,0,0-1.617-.93A2.758,2.758,0,0,1,11,1.375M4.125,7.529A2.775,2.775,0,0,1,6.979,4.813a2.827,2.827,0,0,1,1.477.412A4.708,4.708,0,0,0,6.188,9.281a8.287,8.287,0,0,0,.344,2.3c-1.513-.446-2.406-2.3-2.406-4.055M1.375,17.771V16.6c0-1.685,1.271-2.271,2.956-2.82a10.48,10.48,0,0,0,1-.378,2.244,2.244,0,0,0,.721-.55,5.606,5.606,0,0,0,1.135.206,6.587,6.587,0,0,0,1.341,1.685l-.208.1c-.24.1-.617.242-1.031.38-1.237.412-3.058,1-3.953,2.542Zm19.25,0H18.7a6.239,6.239,0,0,0-3.68-2.44.671.671,0,0,0-.859.448.685.685,0,0,0,.448.859c1.753.583,3.3,1.271,3.3,3.3v.688H4.125v-.687c0-2.062,1.547-2.75,3.575-3.4a5.591,5.591,0,0,0,1.169-.446,2.26,2.26,0,0,0,.789-.586,3.185,3.185,0,0,0,1.341.31,4.841,4.841,0,0,0,3.849-2.75,3.284,3.284,0,0,0,1.135-.206,2.269,2.269,0,0,0,.721.55,10.48,10.48,0,0,0,1,.378c1.651.55,2.956,1.135,2.956,2.82v1.167Z",
    fill: "#2e728c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftIcon);
export default __webpack_public_path__ + "static/media/Microsoft-icon.02f349a3c770a16a6e93d5865f825643.svg";
export { ForwardRef as ReactComponent };